import React, { memo } from "react";

function FloatingCart({ carrito, total, onClick }) {
  if (!carrito || carrito.length === 0) {
    return null;
  }

  const cantidadTotal = carrito.reduce(
    (sum, item) => sum + (item.cantidad || 1),
    0,
  );

  return (
    <>
      <style>
        {`
          @keyframes floatingCartEntrada {
            from {
              opacity: 0;
              transform: translate(-50%, 18px) scale(0.96);
            }
            to {
              opacity: 1;
              transform: translate(-50%, 0) scale(1);
            }
          }

          .floating-cart-mitico {
            animation: floatingCartEntrada 0.28s ease-out;
          }

          .floating-cart-mitico:active {
            transform: translateX(-50%) scale(0.985);
          }
        `}
      </style>

      <button
        className="floating-cart-mitico"
        onClick={onClick}
        style={{
          position: "fixed",
          bottom: "18px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "calc(100% - 28px)",
          maxWidth: "520px",
          background:
            "linear-gradient(135deg, #111 0%, #1f1f1f 55%, #3a2a1b 100%)",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.12)",
          borderRadius: "22px",
          padding: "12px 14px",
          zIndex: 9999,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "14px",
          fontWeight: "900",
          boxShadow: "0 12px 30px rgba(0,0,0,0.28)",
          cursor: "pointer",
          boxSizing: "border-box",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            minWidth: 0,
          }}
        >
          <span
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              backgroundColor: "#fff",
              color: "#111",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "17px",
              boxShadow: "0 3px 8px rgba(0,0,0,0.18)",
              flexShrink: 0,
            }}
          >
            🛒
          </span>

          <span
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              lineHeight: "1.15",
              minWidth: 0,
            }}
          >
            <span
              style={{
                fontSize: "13px",
                fontWeight: "950",
                whiteSpace: "nowrap",
              }}
            >
              Ver pedido
            </span>

            <span
              style={{
                fontSize: "11px",
                fontWeight: "700",
                color: "rgba(255,255,255,0.72)",
                whiteSpace: "nowrap",
              }}
            >
              {cantidadTotal} producto
              {cantidadTotal !== 1 ? "s" : ""}
            </span>
          </span>
        </span>

        <span
          style={{
            backgroundColor: "rgba(255,255,255,0.12)",
            border: "1px solid rgba(255,255,255,0.16)",
            padding: "8px 12px",
            borderRadius: "16px",
            fontSize: "14px",
            fontWeight: "950",
            whiteSpace: "nowrap",
          }}
        >
          ${Number(total || 0).toFixed(2)} MXN
        </span>
      </button>
    </>
  );
}

export default memo(FloatingCart);
